<div class="report-container">

    <div [class.display-none]="showPropertyDetails">

        <app-report-sub-menu [menuList]="transactionMenu"
            (menuChangeValue)="menuChangeValue($event)"
            [activeTab]="activeTab"
            [activeTabName]="activeTabName"
            ></app-report-sub-menu>
            <ng-container *ngIf="overViewLoading">
                <app-skeleton-loader [reportType]="chartView.overView" [loaderSize]="4" [gridColumn]="2" [height]="'150px'"
                    ></app-skeleton-loader>
            </ng-container>
        <div class="report-tabsection"  id="{{transactionsMenuEnum.overview}}"
            [ngClass]="{ 'scroll': currentScroll === transactionsMenuEnum.overview}">


            <div class="report-overview report-overview-2col hv-transactions-overview" *ngIf="!overViewLoading">
                <app-overview-card
                [card_title]="'reports.total_property_transactions'"
                [total_current]="propertyTransactionOverview?.total_property_transaction"
                [total_prev]="propertyTransactionOverview?.prev_year_total_property_transaction"
                [total_percentage]="propertyTransactionOverview?.total_percentage_property_transaction"
                [minDate]="propertyTransactionOverview?.min_date"
                [maxDate]="propertyTransactionOverview?.max_date"
                ></app-overview-card>

                <app-overview-card
                [card_title]="'reports.avg_properties_transaction_rate'"
                [total_current]="placeCode == BHRCHECK  ? propertyTransactionOverview?.average_property_transaction_price_sqm : propertyTransactionOverview?.average_property_transaction_price"
                [total_prev]="propertyTransactionOverview?.prev_year_average_property_transaction_price"
                [total_percentage]="propertyTransactionOverview?.total_percentage_avg_property_transaction"
                [uniType]="UnitTypeEnum.currencywithsqm"
                [bhr_price_sqft]="placeCode == BHRCHECK ? propertyTransactionOverview?.average_property_transaction_price : null"
                [formatInternation]="false"
                [minDate]="propertyTransactionOverview?.min_date"
                [maxDate]="propertyTransactionOverview?.max_date"
                ></app-overview-card>

                <app-overview-card
                [card_title]="'reports.total_units_transactions'"
                [total_current]="unitTransactionOverview?.total_unit_transaction"
                [total_prev]="unitTransactionOverview?.prev_year_total_unit_transaction"
                [total_percentage]="unitTransactionOverview?.total_percentage_unit_transaction"
                [minDate]="unitTransactionOverview?.min_date"
                [maxDate]="unitTransactionOverview?.max_date"
                ></app-overview-card>

                <app-overview-card
                [card_title]="'reports.avg_units_transaction_rate'"
                [total_current]="unitTransactionOverview?.average_unit_transaction_price"
                [total_prev]="unitTransactionOverview?.prev_year_average_unit_transaction_price"
                [total_percentage]="unitTransactionOverview?.total_percentage_avg_unit_transaction"
                [uniType]="UnitTypeEnum.currencywithsqm"
                [formatInternation]="false"
                [minDate]="unitTransactionOverview?.min_date"
                [maxDate]="unitTransactionOverview?.max_date"
                ></app-overview-card>
            </div>
        </div>

        <div class="report-tabsection" id="{{transactionsMenuEnum.property_transaction}}"
            [ngClass]="{ 'scroll': currentScroll === transactionsMenuEnum.property_transaction}">
            <app-report-year-dropdown
            [reportType]="'property'"
            (selectedYear)="selectedYear($event)"
        ></app-report-year-dropdown>
            <div class="report-model">

                <div class="report-model-header">
                    <div class="info w-72">
                        <h3>{{"reports.propertyTransactions" | translate}}</h3>
                        <span class="totalTransaction">({{ propertyTransactionActualCount | number:'1.0-1' }} {{"reports.actual_transactions_with" | translate}} 
                            {{ propertyTransactionAuctionCount | number:'1.0-1' }} {{"reports.auctions" | translate}} 
                            {{"reports.andSymbol" | translate}} 
                            {{ propertyTransactionEstimatedCount | number:'1.0-1' }} {{"reports.quotes" | translate}})</span>
                    </div>

                </div>

                <app-report-datatable-property-transactions class="propertyTransaction-table" [tableName]="'propertyTransactions'"
                [tableColumns]="propertyTransactionColumns" [tableData]="propertyTransactiondata" [dataLength]="propertyTransactionCount" (sort)="sortData($event, 'property_transaction')" (pageEvent)="onPageEvent($event, 'property_transaction')" [showEstaterText]="true" [showLoader]="!propertyTransactiondataLoading" [allowExcelDownload]="true" (excelDownload)="downloadExcel($event, 'property', 'a')" [downloadLoading]="downloadLoading['a']"
                ></app-report-datatable-property-transactions>


            </div>
        </div>
        <div class="report-tabsection" id="{{transactionsMenuEnum.unit_transaction}}" [ngClass]="{ 'scroll': currentScroll === transactionsMenuEnum.unit_transaction}">
            <app-report-year-dropdown
            [reportType]="'unit'"
            (selectedYear)="selectedYear($event)"
        ></app-report-year-dropdown>
            <div class="report-model">

                <div class="report-model-header">
                    <div class="info w-72">
                        <h3>{{"reports.unitTransactions" | translate}}</h3>
                        <span class="totalTransaction">({{unitTransactionActualCount }} {{" "+("reports.actual_transactions_with" |translate)+" "}} 
                            {{ unitTransactionAuctionCount }} {{" "+("reports.auctions" | translate)}} 
                            {{"reports.andSymbol" | translate}} 
                            {{ unitTransactionEstimatedCount }} {{" "+("reports.quotes" | translate)}})</span>
                    </div>
                    <!-- <search-bar></search-bar> -->
                </div>
                <app-report-datatable-unit-transactions class="propertyTransaction-table"
                [tableColumns]="unitTransactionColumns" [tableData]="unitTransactiondata" [dataLength]="unitTransactionCount" (sort)="sortData($event, 'unit_transaction')" (pageEvent)="onPageEvent($event, 'unit_transaction')" [showEstaterText]="true" [showLoader]="!unitTransactiondataLoading" [allowExcelDownload]="true" (excelDownload)="downloadExcel($event, 'unit', 'b')" [downloadLoading]="downloadLoading['b']"
                ></app-report-datatable-unit-transactions>
                

            </div>
        </div>
    </div>
</div>
